<div class="badges">
  <div *ngFor="let badge of badges">
    <a *ngIf="badge.link" href="{{badge.link}}" target="_blank">
      <img src="{{getImgPath(badge.image_id)}}" [alt]="badge?.title" matTooltipPosition="above" matTooltip="{{badge.title}}" loading="lazy" tabindex="1">
    </a>
    <a *ngIf="!badge.link" class="disabled">
      <img src="{{getImgPath(badge.image_id)}}" [alt]="badge?.title" matTooltipPosition="above" matTooltip="{{badge.title}}" loading="lazy" tabindex="1">
    </a>
  </div>
</div>
